import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceContractDelegation } from "../../Model/ServiceContractDelegation/ServiceContractDelegation";

export async function deleteServiceContractDelegationService(ServiceContractDelegationId) {
    let response = await getAPIResponse("/v1/service-contract-delegation/" + ServiceContractDelegationId, {}, "DELETE");
    if (response === null) {
        return null;
    }
    let serviceContractDelegation = ServiceContractDelegation.createFromResponseData(response);
    return serviceContractDelegation;
}
